import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} productDetailedBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  productDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  const excelData = [];

  let totalIncome = 0;

  for (let item = 0; item < productDetailedBalance.length; item++) {
    const balance = productDetailedBalance[item];
    let productConceptArray = [];
    let productTotalPrice = 0;
    let productConcept = "";
    let employeeListArray = [];
    let employeeCountArray = [];
    let employeeList = "";
    let employeeIdArray = [];
    let index = 0;
    balance.Sell_details.forEach((element) => {
      element.Employees.forEach((employee) => {
        if (employeeIdArray.includes(employee.id)) {
          index = employeeIdArray.findIndex((id) => id === employee.id);
          employeeCountArray[index] += 1;
        } else {
          employeeIdArray.push(employee.id);
          employeeCountArray.push(1);
          employeeListArray.push(employee.name + " " + employee.lastname);
        }
      });
    });

    for (let index = 0; index < employeeListArray.length; index++) {
      employeeListArray[index] =
        employeeCountArray[index] + " " + employeeListArray[index];
    }
    employeeList = employeeListArray.join("/");

    balance.Sell_details.forEach((element) => {
      productConceptArray.push(element.quantity + " " + element.Product.name);
    });
    productConcept = productConceptArray.join("/");

    balance.Sell_details.forEach((sell_detail) => {
      productTotalPrice += sell_detail.total_net;
    });

    totalIncome += productTotalPrice;

    excelData.push({
      order: item + 1,
      customer: `${balance.Customer.name} ${balance.Customer.lastname}`,
      employee: employeeList,
      products: productConcept,
      paymentType: balance.Sell_payment_type.name,
      totalPrice: productTotalPrice,
    });
  }
  excelData.push({
    order: "",
    customer: "TOTAL",
    employee: "",
    products: "",
    paymentType: "",
    totalPrice: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR PRODUCTS DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "employee",
            outValue: "EMPLEADOS",
          },
          {
            inValue: "products",
            outValue: "CONCEPTO",
          },
          {
            inValue: "paymentType",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "totalPrice",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-detallado-por-producto_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-producto_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};

/**
 *
 * @param {any[]} productBalance
 * @returns {Workbook}
 */
export const exportExcelGeneral = async (
  productBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalQuantity = 0;
  let totalIncome = 0;

  const excelData = [];

  for (let item = 0; item < productBalance.length; item++) {
    const balance = productBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.name,
      quantity: balance.unitsbought,
      total: balance.totalbought,
    });

    totalQuantity += balance.unitsbought;
    totalIncome += balance.totalbought;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR PRODUCTOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "PRODUCTO",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileNameGeneral(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileNameGeneral = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-producto_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-producto_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ProductBalance/excel.js